const steps = [
  { n: "01", t: "Échange & visite", d: "Compréhension de vos besoins, visite des lieux gratuite, identification des contraintes." },
  { n: "02", t: "Devis sur mesure", d: "Proposition détaillée et transparente sous 48h. Pas de coût caché." },
  { n: "03", t: "Planification", d: "Mise en place d'un planning et désignation d'une équipe dédiée et identifiable." },
  { n: "04", t: "Intervention", d: "Exécution du protocole avec produits écolabel et matériel professionnel." },
];

export default function Process() {
  return (
    <section id="process" className="section-pad bg-card/30 border-y border-border">
      <div className="grid lg:grid-cols-12 gap-10 mb-16">
        <div className="lg:col-span-5">
          <div className="eyebrow mb-6">Notre méthode</div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-light leading-[1]">
            Une approche<br />
            <span className="italic text-[hsl(var(--accent))]">en quatre temps</span>.
          </h2>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 flex items-end">
          <p className="text-muted-foreground leading-relaxed">
            Une démarche structurée qui garantit cohérence, qualité et sérénité — du premier contact
            jusqu'au suivi de la prestation.
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-border">
        {steps.map((s, i) => (
          <div
            key={i}
            data-testid={`process-step-${i}`}
            className="bg-background p-8 lg:p-10 hover:bg-card/60 transition-colors duration-500 group"
          >
            <div className="font-serif text-5xl text-[hsl(var(--accent))]/40 group-hover:text-[hsl(var(--accent))] transition-colors mb-8">
              {s.n}
            </div>
            <h3 className="font-serif text-xl mb-3">{s.t}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{s.d}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
